import {
    FETCH_DEVICE_CONFIG,
    FETCH_DEVICE_CONFIG_FAILURE,
    FETCH_DEVICE_CONFIG_SUCCESS,
    UPDATE_DEVICE_CONFIG,
    UPDATE_DEVICE_CONFIG_FAILURE,
    UPDATE_DEVICE_CONFIG_SUCCESS,
  } from 'constants/ActionTypes';
  
  export const fetch_device_config = payload => {
    return {
      type: FETCH_DEVICE_CONFIG,
      payload,
    };
  };
  
  export const fetch_device_config_success = payload => {
    return {
      type: FETCH_DEVICE_CONFIG_SUCCESS,
      payload,
    };
  };
  
  export const fetch_device_config_failure = payload => {
    return {
      type: FETCH_DEVICE_CONFIG_FAILURE,
      payload,
    };
  };
  
  export const update_device_config = payload => {
    return {
      type: UPDATE_DEVICE_CONFIG,
      payload,
    };
  };
  
  export const update_device_config_success = payload => {
    return {
      type: UPDATE_DEVICE_CONFIG_SUCCESS,
      payload,
    };
  };
  
  export const update_device_config_failure = payload => {
    return {
      type: UPDATE_DEVICE_CONFIG_FAILURE,
      payload,
    };
  };
  